function convertFahrenheitToCelsius(num) {
  let eq =
    "Converting " +
    num +
    "° fahrenheit to celsius: \n" +
    "((" +
    num +
    " - 32) * 5) / 9 = ";
  let rep = ((num - 32) * 5) / 9;
  return eq + rep.toFixed(2);
}

function convertFahrenheitToKelvin(num) {
  let eq =
    "Converting " +
    num +
    "° fahrenheit to kelvin: \n" +
    "((" +
    num +
    " 459.67) * 5) / 9 = ";
  let rep = ((num + 459.67) * 5) / 9;
  return eq + rep.toFixed(3);
}

function convertFahrenheitToRankine(num) {
  let eq =
    "Converting " +
    num +
    "° fahrenheit to rankine: \n" +
    "(" +
    num +
    " 459.67) = ";
  let rep = num + 459.67;
  return eq + rep.toFixed(3);
}

function convertFahrenheitToDelisle(num) {
  let eq =
    "Converting " +
    num +
    "° fahrenheit to delisle: \n" +
    "((212 -" +
    num +
    " ) * 5) / 6 = ";
  let rep = ((212 - num) * 5) / 6;
  return eq + rep.toFixed(2);
}

function convertFahrenheitToNewton(num) {
  let eq =
    "Converting " +
    num +
    "° fahrenheit to newton: \n" +
    "((" +
    num +
    " - 32) * 11) / 60 = ";
  let rep = ((num - 32) * 11) / 60;
  return eq + rep.toFixed(2);
}

function convertFahrenheitToRéaumur(num) {
  let eq =
    "Converting " +
    num +
    "° fahrenheit to réaumur: \n" +
    "((" +
    num +
    " - 32 )* 4) / 9 = ";
  let rep = ((num - 32) * 4) / 9;
  return eq + rep.toFixed(2);
}

function convertFahrenheitToRømer(num) {
  let eq =
    "Converting " +
    num +
    "° fahrenheit to rømer: \n" +
    "(((" +
    num +
    " -32) * 7) / 4) + 7.5 = ";
  let rep = ((num - 32) * 7) / 4 + 7.5;
  return eq + rep.toFixed(3);
}

export {
  convertFahrenheitToRømer,
  convertFahrenheitToRéaumur,
  convertFahrenheitToNewton,
  convertFahrenheitToDelisle,
  convertFahrenheitToRankine,
  convertFahrenheitToKelvin,
  convertFahrenheitToCelsius
};
